import Image from 'app/Components/Shared/Image/image';
import React from "react";
import Config from "app/Config";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import EpiContext from "@episerver/spa-core/Spa";

export const SuccessPage = ({subscriber}) => {
    return (
        <div className={"content"}>
            <div className={'resultPage'}>
            <Image src={require('../images/success.svg')} alt={"success"} />
            <span className={'title'}>
ה-SIM החדש הופעל<br/>
למנוי {subscriber} בהצלחה!</span>

            <span className={'moreInfo'}>
         עכשיו אפשר לכבות את המכשיר,<br/>
להוציא את ה-SIM הישן, ולהחליף ב-SIM החדש</span>

            <BtnSubmit
                text={'חזרה לאיזור האישי'}
                onclick={() => EpiContext.navigateTo(Config.lobbyUrl)}
            />
        </div>
</div>
)
}
